import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.5 6.14V18.44L15.34 16.72V4.42L19.5 6.14ZM10.06 6.98L13.94 4.68V16.98L10.06 19.28V6.98ZM8.66 7.2V19.5L4.5 17.78V5.48L8.66 7.2Z" />
    </SvgIcon>
  );
});
